import validation from './validation.js'

var conditionalFields = function (el, editables) {
	return {
		elementsWithEvents: [],
		init: function () {
			this.form = el

			this.editablesSelectorPrefix = editables ? '' : ':not(.collapsed) > '
			var conditional = this.form.querySelectorAll(this.editablesSelectorPrefix + '[data-conditional]:not(.invisible-empty-checkbox)')

			// mark as initialised
			this.form.classList.add('conditional-init-done')

			for (var i = conditional.length - 1; i >= 0; i--) {
				var conditionalParentName = conditional[i].getAttribute('data-conditional')
				var conditionalParent = this.form.querySelectorAll(this.editablesSelectorPrefix + '[name="' + conditionalParentName + '"]:not(.invisible-empty-checkbox)')
				var validValues = conditional[i].getAttribute('data-valid-values')

				for (var cp = conditionalParent.length - 1; cp >= 0; cp--) {
					if (conditionalParent[cp].type === 'radio' || conditionalParent[cp].type === 'checkbox') {
						if (conditionalParent[cp].value === validValues) {
							conditionalParent[cp].setAttribute('data-cond-value', validValues)
						} else {
							if (!conditionalParent[cp].getAttribute('data-cond-value')) {
								conditionalParent[cp].setAttribute('data-cond-value', '')
							}
						}
					} else if (conditionalParent[cp].tagName === 'SELECT') {
						// conditionalParent[cp].setAttribute('data-cond-value', validValues);

						// add conditional values even when there are already values set
						// check if the values are there already and if not add them

						var splitValidValues = validValues.split(',')
						var setValues = conditionalParent[cp].getAttribute('data-cond-value')
						if (setValues) {
							setValues = setValues.split(',')
						}
						if (!setValues) {
							setValues = []
						}

						var concatValues = splitValidValues.concat(setValues)
						conditionalParent[cp].setAttribute('data-cond-value', concatValues)
					} else {
						conditionalParent[cp].setAttribute('data-cond-value', validValues)
					}

					if (this.elementsWithEvents.indexOf(conditionalParent[cp]) === -1) {
						conditionalParent[cp].addEventListener('change', this.conditionalParentChangeHandler.bind(this))
						this.elementsWithEvents.push(conditionalParent[cp])
					}
				}

				if (conditionalParent.length === 0) continue
				if (conditionalParent[0].type === 'radio') {
					// var form = $(conditionalParent[0]).closest('form')[0]
					var valid = validation.checkOtherRadioWithSameName(conditionalParent[0], this.form)
					if (!valid[0]) {
						conditional[i].classList.add('conditional-hidden')
					} else {
						for (var cp2 = conditionalParent.length - 1; cp2 >= 0; cp2--) {
							if (conditionalParent[cp2].checked && conditionalParent[cp2].value) {
								this.checkForMultipleValues(conditionalParent[cp2])
								break
							} else {
								conditional[i].classList.add('conditional-hidden')
							}
						}
					}
				} else {
					this.checkForMultipleValues(conditionalParent[0])
				}
			}
		},

		conditionalParentChangeHandler: function (e) {
			e.preventDefault()

			this.checkForMultipleValues(e.target)
		},

		checkForMultipleValues: function (target) {
			// var form = $(target).closest('form')[0]
			var condValue = target.getAttribute('data-cond-value').split(',')
			var condName = target.getAttribute('name')

			// when this is a checkbox we can have multiple values so we will have to check all active values
			if (target.type === 'checkbox') {
				var checkboxes = this.form.querySelectorAll(this.editablesSelectorPrefix + '[name="' + condName + '"]:not(.invisible-empty-checkbox)')
				var checkboxValues = []
				for (var cb = checkboxes.length - 1; cb >= 0; cb--) {
					if (checkboxes[cb].checked) {
						checkboxValues.push(checkboxes[cb].value)
					}

					if (cb === 0) {
						condValue = checkboxValues
						this.conditionalParentEvaluate(target, condValue, condName)
					}
				}
			} else {
				this.conditionalParentEvaluate(target, condValue, condName)
			}
		},

		conditionalParentEvaluate: function (target, condValue, condName) {
			if (condValue) {
				var conditionalFields = this.form.querySelectorAll(this.editablesSelectorPrefix + '[data-conditional="' + condName + '"]:not(.invisible-empty-checkbox)')
			}

			for (var cf = conditionalFields.length - 1; cf >= 0; cf--) {
				var match = false
				var fieldValidValues = conditionalFields[cf].getAttribute('data-valid-values')

				if (target.type === 'checkbox') {
					match = this.areCommonElements(condValue, fieldValidValues.split(','))
				} else if (target.type === 'radio') {
					match = this.areCommonElements(condValue, fieldValidValues.split(','))
				} else if (target.tagName === 'SELECT') {
					fieldValidValues = fieldValidValues.split(',')

					match = condValue.indexOf(target.value) > -1 && fieldValidValues.indexOf(target.value) > -1
				} else {
					match = condValue.indexOf(target.value) > -1
				}

				if (match) {
					conditionalFields[cf].classList.remove('conditional-hidden')
					// conditionalFields[cf].querySelector('input').focus();
				} else {
					conditionalFields[cf].classList.add('conditional-hidden')
					this.followConditionalChainHider(conditionalFields[cf], this.form)
				}
			}
		},

		followConditionalChainHider: function (conditionalField, form) {
			// find all conditional fiels dependent of this element and set all hidden
			var inputs = conditionalField.querySelectorAll('input:not(.invisible-empty-checkbox), select, textarea')

			// search for conditional fields based on input name
			for (var i = inputs.length - 1; i >= 0; i--) {
				// reset value
				// var type = inputs[i].type
				// if (type === 'checkbox' || type === 'radio') {
				// 	inputs[i].checked = false
				// 	inputs[i].parentNode.classList.remove('checked')
				// } else if (inputs[i].tagName === 'SELECT') {
				// 	inputs[i].selectedIndex = 0
				// 	var placeholder = inputs[i].parentNode.querySelector('span')
				// 	if (placeholder) placeholder.innerText = inputs[i].options[inputs[i].selectedIndex].innerText
				// } else {
				// 	inputs[i].value = ''
				// }

				var name = inputs[i].getAttribute('name')

				if (name) {
					var conditional = form.querySelectorAll(this.editablesSelectorPrefix + '[data-conditional="' + name + '"]:not(.invisible-empty-checkbox)')

					for (var c = conditional.length - 1; c >= 0; c--) {
						conditional[c].classList.add('conditional-hidden')
						this.followConditionalChainHider(conditional[c], form)
					}
				}
			}
		},

		areCommonElements: function (arr1, arr2) {
			const [shortArr, longArr] = (arr1.length < arr2.length) ? [arr1, arr2] : [arr2, arr1]
			const longArrSet = new Set(longArr)
			return shortArr.some(el => longArrSet.has(el))
		}
	}
}

export default conditionalFields
